<template>
    <v-dialog persistent width="400" :value="cmn_store.is_loading">
        <v-card color="primary darken-2" dark>
            <v-card-text>
                しばらくお待ちください...... 
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            is_loading: {
                type: Boolean,
                require: false,
                default: false,
            },
        },
        data() {
            return {
                isOpen: true,
            };
        },
        watch: {
            is_loading(newVal, oldVal) {
                console.log(newVal, oldVal);
                this.isOpen = newVal;
            },
        },
        computed: {
            ...mapState({
                cmn_store: state => state.common_store,
            }),
        },
    };
</script>
